import ConferenceLayout from "./ConferenceLayout";
import ConferenceList from "./pages/ConferenceList";
import ConferenceBookingDetailStaff from "./pages/ConferenceBookingDetailStaff";

export const conferencePathRoutes = () => [
  {
    name: "ConferenceList",
    path: "list",
    component: ConferenceList
  },
  {
    name: "ConferenceBookingDetailStaff",
    path: ":id",
    component: ConferenceBookingDetailStaff
  },
];

export const conferenceRoutes = {
  path: "conference",
  component: ConferenceLayout,
  children: [
    ...conferencePathRoutes()
  ]
};
